module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0069.jpg?v=a1e372fb";